import React from 'react'
import SelectInput from '../../components/atoms/SelectInput'
import { useTranslation } from 'react-i18next'
import View from './View'
import Input from './Input'
import { COLORS, SPACE } from 'src/theme'

interface Props {
  zipCode: string
  distance: string | number
  onDistanceChange: (val: number | string | boolean) => void
  onZipCodeChange: (val: string) => void
}

const DistanceFilter = ({ zipCode, distance, onZipCodeChange, onDistanceChange }: Props): JSX.Element => {
  const { t } = useTranslation()
  return (
    <View className="flex gap-4">
      <Input
        containerStyles={{ width: '140px', marginLeft: SPACE, fontSize: 14, marginTop: SPACE, color: COLORS.darkGrey }}
        value={zipCode}
        onChange={(e) => {
          onZipCodeChange(e.target.value)
        }}
        label={t('filter_modal.zpi_code_input')}
      />
      <View className="w-[140px]">
        <SelectInput
          value={distance}
          options={[
            { optionLabel: '+ 20 km', optionVal: 20 },
            { optionLabel: '+ 40 km', optionVal: 40 },
            { optionLabel: '+ 80 km', optionVal: 80 },
            { optionLabel: '+ 160 km', optionVal: 160 },
            { optionLabel: '+ 320 km', optionVal: 320 }
          ]}
          onChange={onDistanceChange}
          label={t('filter_modal.area')}
        />
      </View>
    </View>
  )
}

export default DistanceFilter
